import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomButton from "../CustomButton/CustomButton";
import "./newsletter.scss";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const schema = yup
  .object({
    firstName: yup.string().required("Please enter your first name"),
    lastName: yup.string().required("Please enter your last name"),
    email: yup.string().email().required("Please enter valid email"),
    favourite: yup.string().required("Please enter your favourite"),
  })
  .required();

const Newsletter = ({ newsletterChecked, setNewsletterChecked }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const { t } = useTranslation();

  return (
    <div className="newsletter-section display-none-mobile">
      <div className="wrapper">
        <div className="newsletter-section__top">
          <h2 className="newsletter-section__heading">
            {`${t("newsletter.header")}`}
          </h2>
          <p className="newsletter-section__subtext">
            {`${t("newsletter.subtitle")}`}
          </p>
        </div>

        <div className="newsletter-section__form">
          <div className="input-wrapper">
            <input
              type="text"
              placeholder={`${t("newsletter.firstName")}`}
              {...register("firstName")}
            />
            <p>{errors.firstName?.message}</p>
          </div>

          <div className="input-wrapper">
            <input
              type="text"
              placeholder={`${t("newsletter.lastName")}`}
              {...register("lastName")}
            />
            <p>{errors.lastName?.message}</p>
          </div>

          <div className="input-wrapper">
            <input
              type="email"
              placeholder={`${t("newsletter.email")}`}
              {...register("email")}
            />
            <p>{errors.email?.message}</p>
          </div>

          <div className="input-wrapper">
            <input
              placeholder={`${t("newsletter.favAirport")}`}
              {...register("favourite")}
            />
            <p>{errors.favourite?.message}</p>
          </div>

          <label name="newsletter">
            <div className="custom-checkbox-wrapper">
              <input
                onClick={() => setNewsletterChecked(!newsletterChecked)}
                id="newsletter"
                type="checkbox"
                checked={newsletterChecked}
              />
              <span tabIndex={0} aria-label="checkbox" className="custom-checkbox"></span>
              <span className="text">
                {`${t("newsletter.optInText")}`}
                <Trans i18nKey="userMessagesUnread">
                  <a
                    className="compliance-link"
                    target="_blank"
                    rel="noreferrer"
                    href="https://flyflair.com/privacy-policy"
                  >
                    {`${t("newsletter.privacy-policy")}`}
                  </a>{" "}
                  &{" "}
                  <a
                    className="compliance-link"
                    target="_blank"
                    rel="noreferrer"
                    href="https://flair-airlines.myklpages.com/p/mobile-terms-of-service"
                  >
                    {`${t("newsletter.terms")}`}
                  </a>
                  .
                </Trans>
              </span>
            </div>
          </label>
        </div>
        <CustomButton
          classnames="primary"
          name={`${t("newsletter.signup")}`}
          onClick={handleSubmit((d) => console.log(d))}
        />
      </div>
    </div>
  );
};

export default Newsletter;
